if (!customElements.get('product-upsell-cart')) {
  customElements.define('product-upsell-cart', class extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.errorMessage = this.querySelector('[role="alert"]');
      this.spinner = this.querySelector('.loading__spinner');
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (this.cart) this.button.setAttribute('aria-haspopup', 'dialog');
      this.form.addEventListener('change', () => this.updateButton());
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.updateButton();
    }

    selectedItems() {
      return [...this.querySelectorAll('[data-upsell-checkbox]:checked:not(:disabled)')].map((checkbox) => {
        const selector = checkbox.closest('[data-upsell-item]').querySelector('[data-upsell-variant]');
        const option = selector ? selector.selectedOptions[0] : checkbox;
        return { id: option.value, quantity: Number(option.dataset.quantity || 1) };
      });
    }

    updateButton() {
      this.button.disabled = this.busy || this.selectedItems().length === 0;
    }

    async submit(event) {
      event.preventDefault();
      const items = this.selectedItems();
      if (this.busy || !items.length) return;
      this.busy = true;
      this.updateButton();
      this.errorMessage.hidden = true;
      this.button.classList.add('loading');
      this.spinner.classList.remove('hidden');
      try {
        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(this.button);
        }
        const cartAddUrl = new URL(routes.cart_add_url, window.location.origin);
        if (!cartAddUrl.pathname.endsWith('.js')) cartAddUrl.pathname += '.js';
        const response = await fetch(cartAddUrl.toString(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        // Shopify can serve valid cart JSON with a text/javascript content type.
        let result;
        try {
          result = await response.json();
        } catch {
          throw new Error('We could not confirm the cart update. Please check your cart before trying again.');
        }
        if (!response.ok || result.status) {
          throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add the selected items. Please try again.');
        }
        if (!this.cart) {
          window.location = routes.cart_url;
          return;
        }
        result.key = result.items?.[0]?.key || result.key;
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-upsell', cartData: result });
        this.cart.classList.remove('is-empty');
        this.cart.renderContents(result);
      } catch (error) {
        this.errorMessage.textContent = error.message || 'Unable to add the selected items. Please try again.';
        this.errorMessage.hidden = false;
      } finally {
        this.busy = false;
        this.button.classList.remove('loading');
        this.spinner.classList.add('hidden');
        this.updateButton();
      }
    }
  });
}
